import axios from "axios";
import { API, authHeaders } from "./useFleet";

export const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/i;
export const VIN_MSG = "VIN должен содержать 17 латинских букв и цифр, без I, O и Q";

export const readFile = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

/** Validates a document picked by the user; returns an error text or "". */
export const checkDocFile = (file) => {
  if (!file) return "Файл не выбран";
  if (!/^image\//.test(file.type)) return "Поддерживаются изображения JPG / PNG";
  if (file.size > 8 * 1024 * 1024) return "Файл больше 8 МБ";
  return "";
};

export const apiError = (e, fallback = "Не удалось выполнить запрос") => {
  const d = e?.response?.data;
  if (e?.message && !e?.response) return e.message;
  if (d?.detail) return d.detail;
  if (d && typeof d === "object") {
    const t = Object.values(d).flat().join(" ");
    if (t) return t;
  }
  return fallback;
};

export const createTransport = (body) => axios.post(`${API}/transports/`, body, { headers: authHeaders() }).then((r) => r.data);
export const patchTransport = (id, body) => axios.patch(`${API}/transports/${id}/`, body, { headers: authHeaders() }).then((r) => r.data);
export const getTransport = (id) => axios.get(`${API}/transports/${id}/`, { headers: authHeaders() }).then((r) => r.data);

/** «Марка и модель» single field -> {mark, model}. */
export const splitMarkModel = (s) => {
  const parts = String(s || "").trim().split(/\s+/);
  const mark = parts.shift() || "";
  return { mark, model: parts.join(" ") };
};

/** «Иванов Сергей Петрович» -> «Иванов С.П.» (as the Add wireframe's public preview). */
export const shortName = (full) => {
  const parts = String(full || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  return parts[0] + (parts.length > 1 ? " " + parts.slice(1).map((v) => v[0].toUpperCase() + ".").join("") : "");
};

const pad = (n) => String(n).padStart(2, "0");
export const fmtDmy = (d) => `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
export const fmtHm = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;
/** «ДД.ММ.ГГГГ» -> Date (local midnight) or null (the Add wireframe's parser). */
export const parseDmy = (s) => {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(s || ""));
  if (!m) return null;
  const d = new Date(+m[3], +m[2] - 1, +m[1]);
  return d.getDate() === +m[1] && d.getMonth() === +m[2] - 1 ? d : null;
};
export const HM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;
export const dmyToIso = (dmy, hm) => {
  const d = parseDmy(dmy);
  if (!d) return undefined;
  const [h, mi] = (HM_RE.test(hm) ? hm : "00:00").split(":").map(Number);
  d.setHours(h, mi, 0, 0);
  return d.toISOString();
};
